import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { timestamps } from "../utils/fields";

export const offlineSongs = sqliteTable("offline_songs", {
  ...timestamps,
  id: text("id").primaryKey(),
  title: text("title").notNull(),
  artistDisplayText: text("artist_display_text").notNull(),
  artistNames: text("artist_names", { mode: "json" })
    .notNull()
    .$type<string[]>(),
  artistImages: text("artist_images", { mode: "json" })
    .notNull()
    .$type<string[]>(),
  albumId: text("album_id").notNull(),
  duration: integer("duration").notNull(),
  urlOnline: text("url_online"),
  urlOffline: text("url_offline"),
  artistIds: text("artist_ids", { mode: "json" }).notNull().$type<string[]>(),
  trackNumber: integer("track_number").notNull(),
  private: integer("private", { mode: "boolean" }).notNull(),
  accessId: text("access_id"),
  advisory: text("advisory"), // Explicit content advisory (e.g., "Explicit")
  setList: text("set_list", { mode: "json" })
    .$type<{
      entries: Array<{
        startSeconds: number;
        title: string;
        artist: string;
      }>;
    }>(),
});

export type OfflineSong = typeof offlineSongs.$inferSelect;
